import React, { useState } from "react";
import { FCNQuery } from "@hedgefund/shared";
import { useSelector, useDispatch } from "react-redux";
import { createFcnQuery } from "./actions";

const ContactFCNAdmin = () => {
  const [message, setMessage] = useState(null);
  const createNewPostState = useSelector((state) => state.createNewPosts);
  const { loading } = createNewPostState;
  const dispatch = useDispatch();

  const onSuccess = () => {
    if (!loading) {
      setMessage(true);
    } else {
      setMessage(false);
    }
  };

  const onSubmitNewPostHandler = (value) => {
    if (value) {
      dispatch(createFcnQuery(value, onSuccess));
    }
  };
  return (
    <FCNQuery
      onSubmitNewPostHandler={onSubmitNewPostHandler}
      loading={loading}
      message={message}
    />
  );
};

export default ContactFCNAdmin;
